import { all } from 'redux-saga/effects';
import AuthSaga from './saga/AuthSaga';
import UserSaga from './saga/UserSaga';
import TaxSaga from './saga/TaxSaga';
import PaymentSaga from './saga/PaymentSaga';
import StateSaga from './saga/StateSaga';
import userSetupSaga from './saga/UserSetupSaga';
import returnsSaga from './saga/ReturnsSaga';

export default function* rootSaga() {
  yield all([AuthSaga(), UserSaga(), TaxSaga(), PaymentSaga(), StateSaga(), userSetupSaga(), returnsSaga()]);
}
